

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./App.css";

// Initialize React app
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// Service Worker registration with automatic updates
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        // Activate waiting service worker immediately
        if (registration.waiting) {
          registration.waiting.postMessage("SKIP_WAITING");
        }

        // Handle service worker updates
        registration.addEventListener("updatefound", () => {
          const newServiceWorker = registration.installing;
          if (!newServiceWorker) return;

          newServiceWorker.addEventListener("statechange", () => {
            if (newServiceWorker.state === "installed" && navigator.serviceWorker.controller) {
              // New service worker is ready, activate it
              if (registration.waiting) {
                registration.waiting.postMessage("SKIP_WAITING");
              }
            }
          });
        });

        // Force reload when new service worker takes control
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          // Reload the page to ensure new service worker controls all requests
          window.location.reload();
        });
      })
      .catch((error) => {
        console.log("Service Worker registration failed:", error);
      });
  });
}
